import React, { useState } from 'react';
import { Select } from 'antd';

function SelectCountry({ countryList, onSelectCountry, selectedCode, required = false, height, fontSize = '13px', placeholder, disabled = false }) {
    const [searchText, setSearchText] = useState('');

    const options = (countryList ?? []).map(country => ({
        label: country?.name ?? '',
        value: country?.code ?? '',
        item: country,
    }));

    return (
        <Select
            showSearch
            allowClear
            disabled={disabled}
            placeholder={placeholder}
            value={selectedCode || undefined}
            options={options}
            size="middle"
            style={{ width: '100%', fontSize, height: height ?? '40px' }}
            styles={{ popup: { root: { fontSize } } }}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(a, b) => {
                if (!searchText) return 0;
                const lower = searchText.toLowerCase();
                const idxA = (a.label ?? '').toLowerCase().indexOf(lower);
                const idxB = (b.label ?? '').toLowerCase().indexOf(lower);
                return idxA - idxB;
            }}
            onSearch={setSearchText}
            onChange={(val, option) => {
                setSearchText('');
                onSelectCountry(val !== undefined && val !== null ? option?.item : null);
            }}
        />
    );
}

export default SelectCountry;
